export default __webpack_public_path__ + "static/media/image.lanka-travel-mart-pvt-ltd.c3aaab61.png";